/**
 * @file src/helpers/ory/helpers/redirectAndPreserveParams.ts
 * @exports redirectAndPreserveParams
 * @summary Redirects between Ory pages while preserving supported authentication parameters.
 */

import queryString from "query-string";
import { navigateApp } from "src/lib/app-router";
import { validateReturnToUrl } from "./validateReturnToUrl";

// function to do redirections to preserve parameters
export const redirectAndPreserveParams = (redirection: string, extraParams?: Record<string, unknown>) => {
	const { query: webParams } = queryString.parseUrl(window.location.href);
	navigateApp({
		to: redirection,
		search: {
			email: webParams?.email ? String(webParams?.email || "").toLowerCase() : undefined,
			voucherId: webParams?.voucherId ? String(webParams?.voucherId || "") : undefined,
			return_to: validateReturnToUrl(webParams?.return_to as string) ? String(webParams?.return_to || "") : "",
			...(extraParams || {}),
		},
	});
};
